export const width = (device) => {
    const devices = {"phone":{min:10,max:425},"tablet":{min:425,max:768},"laptop":{min:768,max:1024}} 

    if(devices[device].min <= window.innerWidth && window.innerWidth <= devices[device].max)return true
    return false
};
